// extracted by mini-css-extract-plugin
module.exports = {"Row":"CommentReplyButton_Row__5ZPEJ","Button":"CommentReplyButton_Button__AY8tn","AttachmentIcon":"CommentReplyButton_AttachmentIcon__OxJv_"};